import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Constructs a full MinIO URL from a relative path
 * @param path - Relative path to the image (e.g., "blogs/image.png" or null)
 * @returns Full MinIO URL or fallback placeholder
 */
export function getImageUrl(path: string | null | undefined): string {
  // Return placeholder if path is null/undefined/empty
  if (!path || path.trim() === '') {
    return '/placeholder.png';
  }

  // If already an absolute URL, return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  const MINIO_URL = process.env.NEXT_PUBLIC_MINIO_URL || 'http://localhost:9000';
  const MINIO_BUCKET = process.env.NEXT_PUBLIC_MINIO_BUCKET || 'ganesha-storage';
  
  // Clean path: remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // Construct full URL
  return `${MINIO_URL}/${MINIO_BUCKET}/${cleanPath}`;
}
